/* Mo Chara — Premium Scroll Experience v23 */
(function () {
  'use strict';

  function loadScript(src, cb) {
    var s = document.createElement('script');
    s.src = src; s.onload = cb; document.head.appendChild(s);
  }

  function buildHeroScrub(foodSec) {
    // "lager na nDaoine" homepage feature — native, normal document flow.
    // Replaces the old pinned scroll-scrub so it no longer traps the scroll.
    var VIDEO = 'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/mos-lager-slideshow-v2.mp4?v=1786972879';
    var CASE_VARIANT = 55398831063389;

    var sec = document.createElement('section');
    sec.id = 'mc-lager-feat';
    var wrap = document.createElement('div'); wrap.className = 'mc-lf-wrap';

    var copy = document.createElement('div'); copy.className = 'mc-lf-copy';
    copy.innerHTML =
      '<img class="mc-lf-logo" src="https://cdn.shopify.com/s/files/1/0604/4365/6412/files/mos_lager_wordmark.png?v=1786972827" alt="mo\'s lager" width="1200" height="609">' +
      '<h2 class="mc-lf-title">lager na nDaoine</h2>' +
      '<p class="mc-lf-tag">brewed in town, supped all round</p>' +
      '<p class="mc-lf-body">Not your mammies rockshore lager - we are coming for the big boys ' +
      'with this 4.2% crisp, refreshing, gluten free lager. Tastes like more?</p>' +
      '<div class="mc-lf-actions">' +
        '<button type="button" class="mc-lf-btn" id="mc-lf-grab">grab a case</button>' +
        '<a class="mc-lf-link" href="/collections/mos-lager">get the full low down &rarr;</a>' +
      '</div>';

    var media = document.createElement('div'); media.className = 'mc-lf-media';
    var vid = document.createElement('video');
    vid.className = 'mc-lf-video';
    vid.src = VIDEO;
    vid.autoplay = true; vid.loop = true; vid.muted = true; vid.playsInline = true;
    vid.setAttribute('muted', ''); vid.setAttribute('playsinline', ''); vid.setAttribute('preload', 'metadata');
    vid.setAttribute('aria-label', "mo's lager");
    media.appendChild(vid);

    wrap.appendChild(copy); wrap.appendChild(media);
    sec.appendChild(wrap);
    if (foodSec && foodSec.parentNode) { foodSec.parentNode.insertBefore(sec, foodSec); }

    var pl = vid.play(); if (pl && pl.catch) { pl.catch(function () {}); }

    var grab = copy.querySelector('#mc-lf-grab');
    grab.addEventListener('click', function () {
      if (grab.disabled) { return; }
      grab.disabled = true; grab.textContent = 'adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: CASE_VARIANT, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) { throw new Error('add failed'); }
        return r.json();
      }).then(function () {
        grab.textContent = 'added ✓';
        window.location.href = '/cart';
      }).catch(function () {
        grab.disabled = false; grab.textContent = 'grab a case';
        window.location.href = '/products/case-of-stubbies-24x330ml';
      });
    });

    if (window.gsap) {
      var g = window.gsap;
      g.fromTo(copy.querySelectorAll('.mc-lf-logo, .mc-lf-title, .mc-lf-tag, .mc-lf-body, .mc-lf-actions'),
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 0.9, stagger: 0.1, ease: 'power3.out',
          scrollTrigger: { trigger: sec, start: 'top 80%', toggleActions: 'play none none none' } });
      g.fromTo(media, { opacity: 0, y: 40 },
        { opacity: 1, y: 0, duration: 1, ease: 'power3.out',
          scrollTrigger: { trigger: sec, start: 'top 82%', toggleActions: 'play none none none' } });
    }
  }

  function buildSplitScroll(foodSec) {
    var gsap = window.gsap, ST = window.ScrollTrigger;
    var pages = [
      {
        leftImg:  'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/og-028.jpg',
        rightImg: null,
        leftContent:  null,
        rightContent: { label: '', heading: 'grub', desc: 'Sambos by day. Pizzas by night. Plus a new special pop-up menu every month.', cta: 'See the Menu', href: '/pages/grub' }
      },
      {
        leftImg:  null,
        rightImg: 'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/Mo_s_Lager_X_Hephee-46.jpg',
        leftContent:  { label: '', heading: 'merch', desc: 'We\'ve always got something new in the works. Get yourself something here.', cta: 'Shop Now', href: '/collections/mo-chara-merch' },
        rightContent: null
      },
      {
        leftImg:  'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/CincoDeMayoForSam2025-59.jpg',
        rightImg: null,
        leftContent:  null,
        rightContent: { label: '', heading: 'events', desc: 'From kitchen pop-ups &amp; Sunday markets to secret gigs &amp; trad sessions - there\'s always something happening. Check what\'s on here!', cta: "See What's On", href: '/collections/events' }
      }
    ];
    var sec = document.createElement('div'); sec.id = 'mc-split-scroll';
    if (foodSec && foodSec.parentNode) { foodSec.parentNode.insertBefore(sec, foodSec); foodSec.style.display = 'none'; }

    var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function mkContent(c) {
      var d = document.createElement('div'); d.className = 'mc-ss-inner';
      d.innerHTML = (c.label ? '<span class="mc-ss-eyebrow">' + c.label + '</span>' : '') + '<h2 class="mc-ss-heading">' + c.heading + '</h2><p class="mc-ss-desc">' + c.desc + '</p><a href="' + c.href + '" class="mc-ss-cta">' + c.cta + '</a>';
      return d;
    }
    function mkHalf(side, img, content) {
      var h = document.createElement('div'); h.className = 'mc-ss-half mc-ss-half-' + side;
      if (img) {
        var bg = document.createElement('div'); bg.className = 'mc-ss-bg';
        bg.style.backgroundImage = 'url(' + img + ')';
        h.appendChild(bg);
      } else if (content) {
        h.appendChild(mkContent(content));
      }
      return h;
    }

    var panels = [];
    pages.forEach(function (pg) {
      var panel = document.createElement('div'); panel.className = 'mc-ss-panel';
      panel.appendChild(mkHalf('l', pg.leftImg, pg.leftContent));
      panel.appendChild(mkHalf('r', pg.rightImg, pg.rightContent));
      var rule = document.createElement('div'); rule.className = 'mc-ss-rule'; panel.appendChild(rule);
      sec.appendChild(panel);
      panels.push(panel);
    });

    if (rm) {
      panels.forEach(function (p) { p.classList.add('mc-ss-in'); });
      return;
    }
    panels.forEach(function (panel) {
      ST.create({
        trigger: panel,
        start: 'top 78%',
        onEnter: function () { panel.classList.add('mc-ss-in'); }
      });
    });
  }

  function buildMerchScroll(insertBefore) {
    var products = [
      { title: 'mary wallopers tee',     handle: 'one-night-in-mos-tee',                   price: '35.00', img: 'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/odiesmerch-30.jpg?width=480' },
      { title: 'beamish tote bag',        handle: 'beamish-tote-bag',                         price: '20.00', img: 'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/E12E8644-8485-46D9-BE22-C3455DB8A537.jpg?width=480' },
      { title: 'beamish trackie',         handle: 'beamish-trackie',                           price: '100.00', img: 'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/B51F5301-FDC8-4F1C-8F31-753510D097D9.jpg?width=480' },
      { title: 'beamish track pants',     handle: 'beamish-track-pants',                       price: '40.00', img: 'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/22010F5A-2B6D-4B7B-AF24-787E914F2479.jpg?width=480' },
      { title: 'stubby care package',     handle: '6-8-more-beers-tee',                        price: '80.00', img: 'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/Mo_sLagerXHephee-14_335b2309-0184-4f5b-9f61-6a9d5f55908e.jpg?width=480' },
      { title: 'stubby hoodie',           handle: 'just-like-your-da-tee',                     price: '60.00', img: 'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/Mo_s_Lager_X_Hephee-42.jpg?width=480' },
      { title: '6-8 more pints tee',      handle: '6-8-more-pints-tee',                        price: '35.00', img: 'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/Mo_s_Lager_X_Hephee-27.jpg?width=480' },
      { title: 'just like your da tee',   handle: 'just-like-your-da-tee-1',                   price: '35.00', img: 'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/Mo_s_Lager_X_Hephee-46.jpg?width=480' },
      { title: 'mo chara x umbro jersey', handle: 'mo-chara-x-umbro-jersey',                   price: '80.00', img: 'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/MoCharaXUmbro_4-5Ratio_-17.jpg?width=480' },
      { title: 'mobino scarf',            handle: 'mobino-scarf',                              price: '15.00', img: 'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/Screenshot_2025-11-10_at_17.59.03.png?width=480' },
      { title: 'stubby & slice tee',      handle: 'stubby-slice-tee',                          price: '35.00', img: 'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/Screenshot_2025-11-10_at_17.35.38.png?width=480' },
      { title: 'cúpá pint glasses x2', handle: 'cupla-pints-never-harmed-anyone-glass', price: '20.00', img: 'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/DSC00031.jpg?width=480' }
    ];
    products.forEach(function (pr) { var pre = new Image(); pre.src = pr.img; });
    var sec = document.createElement('section'); sec.id = 'mc-merch-scroll';
    var hdr = document.createElement('div'); hdr.className = 'mc-ms-header';
    var ttl = document.createElement('h2'); ttl.className = 'mc-ms-title'; ttl.textContent = 'Go On Buy Some Stuff';
    var slnk = document.createElement('a'); slnk.className = 'mc-ms-shoplink';
    slnk.href = '/collections/mo-chara-merch'; slnk.textContent = 'shop all';
    hdr.appendChild(ttl); hdr.appendChild(slnk); sec.appendChild(hdr);
    var ovf = document.createElement('div'); ovf.className = 'mc-ms-overflow';
    var trk = document.createElement('div'); trk.className = 'mc-ms-track';
    var all = products.concat(products, products, products);
    all.forEach(function (pr) {
      var card = document.createElement('a'); card.className = 'mc-ms-card'; card.href = '/products/' + pr.handle;
      var wrap = document.createElement('div'); wrap.className = 'mc-ms-card-img-wrap';
      var img = document.createElement('img'); img.className = 'mc-ms-img'; img.src = pr.img; img.alt = pr.title;
      img.width = 240; img.height = 320; img.loading = 'eager'; img.decoding = 'async';
      wrap.appendChild(img);
      var info = document.createElement('div'); info.className = 'mc-ms-info';
      var nm = document.createElement('p'); nm.className = 'mc-ms-name'; nm.textContent = pr.title;
      var px = document.createElement('p'); px.className = 'mc-ms-price'; px.textContent = '€' + pr.price;
      info.appendChild(nm); info.appendChild(px); card.appendChild(wrap); card.appendChild(info); trk.appendChild(card);
    });
    ovf.appendChild(trk); sec.appendChild(ovf);
    if (insertBefore && insertBefore.parentNode) { insertBefore.parentNode.insertBefore(sec, insertBefore); }
    var baseX = 0, singleWidth = 0, lastTime = null, rawVel = 0, smoothVel = 0;
    var lastScrollY = window.scrollY, BASE_SPEED = 90, scrollTimer = null;
    window.addEventListener('scroll', function () {
      var sy = window.scrollY; rawVel = Math.abs(sy - lastScrollY) * 60; lastScrollY = sy;
      clearTimeout(scrollTimer); scrollTimer = setTimeout(function () { rawVel = 0; }, 150);
    }, { passive: true });
    function tick(now) {
      if (!singleWidth) { singleWidth = trk.scrollWidth / 4; }
      if (lastTime === null) { lastTime = now; }
      var delta = Math.min((now - lastTime) / 1000, 0.05); lastTime = now;
      smoothVel = smoothVel * 0.85 + rawVel * 0.15;
      var moveBy = BASE_SPEED * (1 + Math.min(smoothVel / 600, 5)) * delta;
      baseX -= moveBy;
      if (singleWidth > 0 && baseX < -singleWidth) { baseX += singleWidth; }
      trk.style.transform = 'translateX(' + baseX.toFixed(2) + 'px)';
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function buildAboutScrub(mountEl) {
    var gsap = window.gsap;
    var imgUrls = [
      'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/Fat_Sals-36_1.jpg?v=1761294066',
      'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/52E021E2-BCB2-45FF-8B1E-31AA4B7A2B71.jpg?v=1730846249',
      'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/Wallopers_Que-15.jpg?v=1728071015'
    ];
    var textData = [
      { side: 'L', html: 'mo chara.' },
      { side: 'R', html: 'my friend.' },
      { side: 'L', html: 'july 2021.' },
      { side: 'R', html: 'three<br>lads.' },
      { side: 'L', html: 'old<br>friends.' },
      { side: 'R', html: 'loads of<br>new ones.' }
    ];
    var sec = document.createElement('div');
    sec.id = 'mc-about-scrub';
    sec.style.cssText = 'position:relative;height:600vh;background:#3A2315;';
    if (mountEl && mountEl.parentNode) { mountEl.parentNode.insertBefore(sec, mountEl); }
    else { document.body.appendChild(sec); }
    var sticky = document.createElement('div'); sticky.className = 'mc-hs-sticky'; sec.appendChild(sticky);
    var imgs = [];
    imgUrls.forEach(function (src, i) {
      var img = document.createElement('img');
      img.src = src; img.alt = 'Mo Chara'; img.className = 'mc-hs-img';
      img.loading = i === 0 ? 'eager' : 'lazy';
      if (i > 0) { img.style.opacity = '0'; }
      sticky.appendChild(img); imgs.push(img);
    });
    var overlay = document.createElement('div'); overlay.className = 'mc-hs-overlay'; sticky.appendChild(overlay);
    var labels = [];
    textData.forEach(function (d) {
      var lbl = document.createElement('div');
      lbl.className = 'mc-hs-label mc-hs-label-' + d.side.toLowerCase();
      lbl.innerHTML = d.html; sticky.appendChild(lbl); labels.push(lbl);
    });
    gsap.set(labels, { yPercent: -50, y: 90, opacity: 0 });
    var PHASE = 1.0, INITIAL_OFFSET = 1.5;
    var master = gsap.timeline({
      scrollTrigger: { trigger: sec, start: 'top top', end: 'bottom bottom', scrub: 0.6 }
    });
    for (var i = 0; i < 6; i++) {
      var p = INITIAL_OFFSET + i * PHASE;
      if (i > 0 && i % 2 === 0) {
        var fi = imgs[i/2 - 1], ti = imgs[i/2];
        if (fi && ti) {
          master.to(fi, { opacity: 0, ease: 'power1.inOut', duration: PHASE * 0.3 }, p - PHASE * 0.15);
          master.to(ti, { opacity: 1, ease: 'power1.inOut', duration: PHASE * 0.3 }, p - PHASE * 0.15);
        }
      }
      master.to(labels[i], { y: 0,   opacity: 1, ease: 'power2.out', duration: PHASE * 0.38 }, p + PHASE * 0.06);
      master.to(labels[i], { y: -90, opacity: 0, ease: 'power2.in',  duration: PHASE * 0.38 }, p + PHASE * 0.56);
    }
  }

  function buildAboutEvents(mountEl) {
    var gsap = window.gsap;
    var pages = [
      {
        leftImg:  'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/52E021E2-BCB2-45FF-8B1E-31AA4B7A2B71.jpg?v=1730846249',
        rightImg: null,
        leftContent:  null,
        rightContent: { label: 'every week', heading: 'a hub &amp;<br>a pub.', desc: 'Markets, comedy nights, pop-ups and proper concerts. Always something on, always worth showing up for.', cta: "see what's on", href: '/collections/events' }
      },
      {
        leftImg:  null,
        rightImg: 'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/Wallopers_Que-15.jpg?v=1728071015',
        leftContent:  { label: 'live music', heading: 'The Mary<br>Wallopers.', desc: 'Some of the finest sessions this side of Dundalk. The kind of night you talk about for years.', cta: 'get tickets', href: '/collections/events' },
        rightContent: null
      }
    ];
    var sec = document.createElement('div');
    sec.id = 'mc-about-events';
    sec.style.cssText = 'position:relative;height:300vh;';
    if (mountEl && mountEl.parentNode) { mountEl.parentNode.insertBefore(sec, mountEl); }
    else { document.body.appendChild(sec); }
    var sticky = document.createElement('div'); sticky.className = 'mc-ss-sticky'; sec.appendChild(sticky);
    var rule = document.createElement('div'); rule.className = 'mc-ss-rule'; sticky.appendChild(rule);
    var leftPanels = [], rightPanels = [];
    function mkContent(c) {
      var d = document.createElement('div'); d.className = 'mc-ss-content';
      d.innerHTML = '<span class="mc-ss-eyebrow">' + c.label + '</span><h2 class="mc-ss-heading">' + c.heading + '</h2><p class="mc-ss-desc">' + c.desc + '</p><a href="' + c.href + '" class="mc-ss-cta">' + c.cta + '</a>';
      return d;
    }
    pages.forEach(function (pg) {
      var lp = document.createElement('div'); lp.className = 'mc-ss-half mc-ss-half-l';
      var lb = document.createElement('div'); lb.className = 'mc-ss-bg';
      if (pg.leftImg) { lb.style.backgroundImage = 'url(' + pg.leftImg + ')'; }
      if (pg.leftContent) { lb.appendChild(mkContent(pg.leftContent)); }
      lp.appendChild(lb); sticky.appendChild(lp); leftPanels.push(lp);
      var rp = document.createElement('div'); rp.className = 'mc-ss-half mc-ss-half-r';
      var rb = document.createElement('div'); rb.className = 'mc-ss-bg';
      if (pg.rightImg) { rb.style.backgroundImage = 'url(' + pg.rightImg + ')'; }
      if (pg.rightContent) { rb.appendChild(mkContent(pg.rightContent)); }
      rp.appendChild(rb); sticky.appendChild(rp); rightPanels.push(rp);
    });
    var dotsEl = document.createElement('div'); dotsEl.className = 'mc-ss-dots'; sticky.appendChild(dotsEl);
    var dotEls = pages.map(function (_, i) {
      var d = document.createElement('div');
      d.className = 'mc-ss-dot' + (i === 0 ? ' mc-ss-on' : '');
      dotsEl.appendChild(d); return d;
    });
    gsap.set(leftPanels.slice(1),  { yPercent: 100  });
    gsap.set(rightPanels.slice(1), { yPercent: -100 });
    gsap.timeline({
      scrollTrigger: {
        trigger: sec, start: 'top top', end: 'bottom bottom', scrub: 0.7,
        onUpdate: function (self) {
          var idx = self.progress < 0.5 ? 0 : 1;
          dotEls.forEach(function (d, i) { d.classList.toggle('mc-ss-on', i === idx); });
        }
      }
    })
    .to(leftPanels[0],  { yPercent: 100,  ease: 'power2.inOut', duration: 1 }, 1)
    .to(rightPanels[0], { yPercent: -100, ease: 'power2.inOut', duration: 1 }, 1)
    .to(leftPanels[1],  { yPercent: 0,    ease: 'power2.inOut', duration: 1 }, 1)
    .to(rightPanels[1], { yPercent: 0,    ease: 'power2.inOut', duration: 1 }, 1);
  }

  function buildAboutCollabs() {
    var trackEl = document.getElementById('mc-about-collabs-track');
    if (!trackEl) return;
    var collabs = [
      { title: 'mo chara x edwin',   img: 'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/MoChara_X_Edwin_-20_1.png?v=1720614072&width=600' },
      { title: 'mo chara x edwin',   img: 'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/MoChara_X_Edwin_-16.png?v=1720615624&width=600' },
      { title: 'mo chara x beamish', img: 'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/B51F5301-FDC8-4F1C-8F31-753510D097D9.jpg?width=600' },
      { title: 'mo chara x umbro',   img: 'https://cdn.shopify.com/s/files/1/0604/4365/6412/files/MoCharaXUmbro_4-5Ratio_-17.jpg?width=600' }
    ];
    var all = collabs.concat(collabs, collabs, collabs);
    all.forEach(function (c) {
      var card = document.createElement('div'); card.className = 'mc-ac-card';
      var img = document.createElement('img');
      img.src = c.img; img.alt = c.title; img.className = 'mc-ac-img';
      img.loading = 'eager'; img.decoding = 'async';
      var lbl = document.createElement('p'); lbl.className = 'mc-ac-label'; lbl.textContent = c.title;
      card.appendChild(img); card.appendChild(lbl);
      trackEl.appendChild(card);
    });
    var baseX = 0, singleWidth = 0, lastTime = null, rawVel = 0, smoothVel = 0;
    var lastScrollY = window.scrollY, BASE_SPEED = 60, scrollTimer = null;
    window.addEventListener('scroll', function () {
      var sy = window.scrollY; rawVel = Math.abs(sy - lastScrollY) * 60; lastScrollY = sy;
      clearTimeout(scrollTimer); scrollTimer = setTimeout(function () { rawVel = 0; }, 150);
    }, { passive: true });
    function tick(now) {
      if (!singleWidth) { singleWidth = trackEl.scrollWidth / 4; }
      if (lastTime === null) { lastTime = now; }
      var delta = Math.min((now - lastTime) / 1000, 0.05); lastTime = now;
      smoothVel = smoothVel * 0.85 + rawVel * 0.15;
      var moveBy = BASE_SPEED * (1 + Math.min(smoothVel / 600, 5)) * delta;
      baseX -= moveBy;
      if (singleWidth > 0 && baseX < -singleWidth) { baseX += singleWidth; }
      trackEl.style.transform = 'translateX(' + baseX.toFixed(2) + 'px)';
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function init() {
    var gsap = window.gsap, ST = window.ScrollTrigger;
    gsap.registerPlugin(ST);
    document.documentElement.classList.add('mc-js');

    var bar = document.createElement('div'); bar.id = 'mc-progress'; document.body.appendChild(bar);
    window.addEventListener('scroll', function () {
      bar.style.width = (window.scrollY / Math.max(1, document.body.scrollHeight - window.innerHeight) * 100).toFixed(1) + '%';
    }, { passive: true });

    if (window.matchMedia('(hover: hover)').matches) {
      var glow = document.createElement('div'); glow.id = 'mc-cursor-glow'; document.body.appendChild(glow);
      document.addEventListener('mousemove', function (e) {
        glow.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px)';
      }, { passive: true });
    }

    var grain = document.createElement('canvas'); grain.id = 'mc-grain'; document.body.appendChild(grain);
    var gctx  = grain.getContext('2d');
    function paintGrain() {
      grain.width = window.innerWidth; grain.height = window.innerHeight;
      var d = gctx.createImageData(grain.width, grain.height);
      for (var j = 0; j < d.data.length; j += 4) {
        var v = (Math.random() * 255) | 0;
        d.data[j] = d.data[j+1] = d.data[j+2] = v; d.data[j+3] = 12;
      }
      gctx.putImageData(d, 0, 0);
    }
    if (window.matchMedia('(min-width: 1000px) and (hover: hover)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) { paintGrain(); }

    function qs(sel, ctx)  { return (ctx || document).querySelector(sel); }
    function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

    var aboutScrubMount = qs('#mc-about-scrub-mount');

    if (!aboutScrubMount) {
      var heroSec       = qs('[id$="hero_rhMed7"]');
      var marqueeSec    = qs('[id$="marquee_izzYrQ"]');
      var foodSec       = qs('[id$="media_with_content_GRV6iJ"]');
      var collGridSec   = qs('[id$="collection_list_t9g7dn"]');
      var productSec    = qs('[id$="product_list_4jqyPz"]');
      var featSec       = qs('[id$="featured_product_4MkrwA"]');
      var collLinksSec  = qs('[id$="collection_links_bnangK"]');
      var newsletterSec = qs('[id$="1769698196e0e7e98a"]');

      if (collGridSec) collGridSec.style.display = 'none';
      if (productSec)  productSec.style.display  = 'none';

      buildHeroScrub(foodSec);
      buildSplitScroll(foodSec);
      buildMerchScroll(featSec || newsletterSec);

      function triggerHeroAnim() {
        if (!heroSec) return;
        var heroImg = qs('img', heroSec);
        if (heroImg) {
          heroImg.parentElement.style.overflow = 'hidden';
          gsap.fromTo(heroImg, { scale: 1.06 }, { scale: 1, duration: 6, ease: 'power1.out' });
        }
        var hto = document.createElement('div'); hto.id = 'mc-hero-text';
        hto.innerHTML =
          '<h2>three lads walk into a bar...</h2>' +
          '<p>After years of talking, we set about recreating what the Irish public house means to a community and began building something we hoped would one day become iconic to our hometown of Dundalk.</p>' +
          '<a href="/pages/about-mos" class="button">get the full story</a>';
        heroSec.appendChild(hto);
        var hh2 = hto.querySelector('h2'), hp = hto.querySelector('p'), ha = hto.querySelector('a');
        gsap.set([hh2, hp, ha], { opacity: 0, y: 28 });
        gsap.timeline({ scrollTrigger: { trigger: heroSec, start: 'top top', end: '+=700', pin: true, scrub: 0.8 } })
          .to(hh2, { opacity: 1, y: 0, ease: 'power2.out' }, 0)
          .to(hp,  { opacity: 1, y: 0, ease: 'power2.out' }, 0.38)
          .to(ha,  { opacity: 1, y: 0, ease: 'power2.out' }, 0.68);
      }

      if (heroSec) { triggerHeroAnim(); }
      ST.refresh();

      if (marqueeSec) {
        gsap.fromTo(marqueeSec, { opacity: 0, scaleX: 0.92 }, { opacity: 1, scaleX: 1, duration: 1.3, ease: 'expo.out',
          scrollTrigger: { trigger: marqueeSec, start: 'top 90%', toggleActions: 'play none none none' } });
      }
      if (featSec) {
        var featImg = qs('img', featSec), featTxt = qsa('h1,h2,h3,p,[class*="price"]', featSec);
        if (featImg) {
          featImg.parentElement.style.overflow = 'hidden';
          gsap.fromTo(featImg, { clipPath: 'inset(100% 0 0 0)', scale: 1.08 },
            { clipPath: 'inset(0% 0 0 0)', scale: 1, duration: 1.4, ease: 'power3.inOut',
              scrollTrigger: { trigger: featSec, start: 'top 80%', toggleActions: 'play none none none' } });
        }
        if (featTxt.length) {
          gsap.fromTo(featTxt, { opacity: 0, y: 40 },
            { opacity: 1, y: 0, duration: 1, stagger: 0.1, ease: 'power3.out',
              scrollTrigger: { trigger: featSec, start: 'top 75%', toggleActions: 'play none none none' } });
        }
      }
      if (collLinksSec) {
        var links = qsa('[class*="collection-links__link"], [class*="collection-link"], li', collLinksSec);
        if (!links.length) { links = qsa('a', collLinksSec); }
        gsap.fromTo(links, { opacity: 0, x: -40 },
          { opacity: 1, x: 0, duration: 0.7, stagger: { amount: 0.7 }, ease: 'power3.out',
            scrollTrigger: { trigger: collLinksSec, start: 'top 82%', toggleActions: 'play none none none' } });
      }
      if (newsletterSec) {
        gsap.fromTo(newsletterSec, { opacity: 0, y: 40 },
          { opacity: 1, y: 0, duration: 1, ease: 'power3.out',
            scrollTrigger: { trigger: newsletterSec, start: 'top 88%', toggleActions: 'play none none none' } });
      }

    } else {
      var eventsMount = qs('#mc-about-events-mount');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      buildAboutScrub(aboutScrubMount);
      if (eventsMount) { buildAboutEvents(eventsMount); }
      buildAboutCollabs();

      if (reducedMotion) { ST.refresh(); return; }

      var aboutHero = qs('#mc-about-hero');
      if (aboutHero) {
        var heroImgA = qs('img', aboutHero);
        if (heroImgA) { gsap.fromTo(heroImgA, { scale: 1.08 }, { scale: 1, duration: 7, ease: 'power1.out' }); }

        var heroEyeA = qs('.mc-ah-eyebrow', aboutHero);
        if (heroEyeA) { gsap.fromTo(heroEyeA, { opacity: 0 }, { opacity: 1, duration: 0.7, ease: 'power2.out', delay: 0.15 }); }

        var heroWords = qsa('.mc-ah-word', aboutHero);
        if (heroWords.length) {
          gsap.set(heroWords, { opacity: 0, y: 55 });
          gsap.to(heroWords, { opacity: 1, y: 0, duration: 1.1, stagger: 0.12, ease: 'power3.out', delay: 0.32 });
        }

        var heroDescA = qs('.mc-ah-desc', aboutHero);
        if (heroDescA) { gsap.fromTo(heroDescA, { opacity: 0, y: 22 }, { opacity: 1, y: 0, duration: 0.9, ease: 'power2.out', delay: 0.9 }); }
      }

      var chapterTrack = qs('.mc-chapter-track');
      if (chapterTrack) {
        gsap.to(chapterTrack, { x: '-28%', ease: 'none', scrollTrigger: {
          trigger: '#mc-about-chapter-1', start: 'top bottom', end: 'bottom top', scrub: 0.8
        }});
      }

      var lagerEl = qs('#mc-about-lager');
      if (lagerEl) {
        var lagerImg = qs('img', lagerEl);
        var lagerTxt = qsa('.mc-al-eyebrow, .mc-al-heading, .mc-al-body, .mc-al-cta', lagerEl);
        if (lagerImg) {
          lagerImg.parentElement.style.overflow = 'hidden';
          gsap.fromTo(lagerImg, { clipPath: 'inset(100% 0 0 0)', scale: 1.06 },
            { clipPath: 'inset(0% 0 0 0)', scale: 1, duration: 1.6, ease: 'power3.inOut',
              scrollTrigger: { trigger: lagerEl, start: 'top 80%', toggleActions: 'play none none none' } });
        }
        if (lagerTxt.length) {
          gsap.fromTo(lagerTxt, { opacity: 0, y: 35 },
            { opacity: 1, y: 0, duration: 1, stagger: 0.12, ease: 'power3.out',
              scrollTrigger: { trigger: lagerEl, start: 'top 75%', toggleActions: 'play none none none' } });
        }
      }

      var awardsEl = qs('#mc-about-awards');
      if (awardsEl) {
        var awardRule = qs('.mc-aw-rule', awardsEl);
        if (awardRule) {
          gsap.fromTo(awardRule, { scaleX: 0 }, { scaleX: 1, duration: 1.2, ease: 'power3.out',
            scrollTrigger: { trigger: awardsEl, start: 'top 85%', toggleActions: 'play none none none' } });
        }
        gsap.fromTo(qsa('.mc-aw-eyebrow, .mc-aw-item, .mc-aw-divider', awardsEl),
          { opacity: 0, y: 40 },
          { opacity: 1, y: 0, duration: 1.1, stagger: 0.18, ease: 'power3.out',
            scrollTrigger: { trigger: awardsEl, start: 'top 82%', toggleActions: 'play none none none' } });
      }

      ST.refresh();
    }
  }

  loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js', function () {
    loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js', init);
  });
})();